/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSeparator = createReactComponent("separator", "IconSeparator", [
  ["path", { d: "M3 12l0 .01", key: "svg-0" }],
  ["path", { d: "M7 12l10 0", key: "svg-1" }],
  ["path", { d: "M21 12l0 .01", key: "svg-2" }]
]);

export { IconSeparator as default };
//# sourceMappingURL=IconSeparator.js.map
